import { Component, ElementRef, inject, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbCalendar, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { DayOfWeekCheck } from '@pos-app/data';
import { EventService } from '@pos-app/core-ui';
import { takeUntil } from 'rxjs/operators';
import { Subject, BehaviorSubject } from 'rxjs';
import { arraysContainSame, getformatedTimeHHMMForApi, getDaysOfWeek } from '../../scheduler-helper';
import { ToastrService } from 'ngx-toastr';
import moment from 'moment';
import { ConfirmationService } from 'primeng/api';

@Component({
    selector: 'app-schedulerSetWorkshopHours',
    styleUrls: ['./schedulerSetWorkshopHours.component.css'],
    templateUrl: './schedulerSetWorkshopHours.component.html',
    standalone: false
})
export class SchedulerSetWorkshopHours implements OnInit {
  @ViewChild('d2', { static: true }) d2;
  unSubscribe$ = new Subject<void>();
  @Input() actionSetWorkshopDay;
  @Input() defaultBranch: string;
  @Input() currentDate: string;
  @Input() globalData;
  setWorkshopDayHourForm: UntypedFormGroup;
  private _loadingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  loading$ = this._loadingSubject.asObservable();
  get loading(): boolean {
    return this._loadingSubject.value;
  }
  set loading(v: boolean) {
    this._loadingSubject.next(v);
  }
  fetchedMonth: Array<String> = [];
  showRecurringDay: boolean = false;
  originalWorkshopDate: Array<String> = [];
  isFormValid: boolean = false;
  daysOfWeek: Array<DayOfWeekCheck> = getDaysOfWeek();
  today = inject(NgbCalendar).getToday();
  model: NgbDateStruct;
  date: { year: number; month: number };
  showDateTimeFrame: boolean = false;
  isFromRecurring: boolean = false;
  currentMonth: number;
  hideDaysOptions: boolean;
  selectedworkshopDates: Array<string> = [];
  workshopOpenDates: Array<String> = [];
  timeframeEditable: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private fb: UntypedFormBuilder,
    private eventService: EventService,
    private toastr: ToastrService,
    private renderer: Renderer2,
    private confirmationService: ConfirmationService
  ) {}

  ngOnInit(): void {
    this.setWorkshopDayHourForm = this.fb.group({
      recurringDays: [[]],
      recurringStartDate: [''],
      recurringEndDate: [''],
      timeframe: [''],
    });

    this.setWorkshopDayHourForm.get('timeframe').valueChanges.subscribe(() => {
      const val = this.setWorkshopDayHourForm.getRawValue();
      if (val.timeframe === 1) {
        this.showDateTimeFrame = true;
        this.setWorkshopDayHourForm.patchValue({
          recurringStartDate: this.currentDate,
          recurringEndDate: this.currentDate,
        });
        this.hideDaysOptions = true;
        this.streamOpened(event);
        this.timeframeEditable = false;

      }
      if (val.timeframe === 2) {
        this.showDateTimeFrame = true;
        this.setWorkshopDayHourForm.patchValue({
          recurringStartDate: this.currentDate,
          recurringEndDate: '01/01/2040',
        });
        this.selectedworkshopDates = [];
        this.hideDaysOptions = false;
        this.isFormValid = false;
        this.timeframeEditable = false;

      }
      if (val.timeframe === 3) {
        this.showDateTimeFrame = true;
        this.setWorkshopDayHourForm.patchValue({
          recurringStartDate: '',
          recurringEndDate: '',
        });
        this.selectedworkshopDates = [];
        this.hideDaysOptions = false;
        this.timeframeEditable = true;

      }
    });
  }

  submitWorkshopDayHourForm(submit) {
    this.activeModal.close();
  }

  onChange(form) {
    // reset the form value to the newly emitted form group value.
    this.setWorkshopDayHourForm = form;
  }
  streamOpened(event) {
    this.showRecurringDay = false;
   
    setTimeout(() => {
      document.querySelectorAll('.ngb-dp-month').forEach((el) => {
        el.className = 'ngb-dp-month-custom';
      });
      document.querySelectorAll('.ngb-dp-weekdays').forEach((el) => {
        el.className = 'ngb-dp-week ngb-dp-weekdays ng-star-inserted ngb-dp-weekdays-custom';
      });
      document.querySelectorAll('.ngb-dp-week').forEach((el, i) => {
        if (i === 0) {
          el.className = 'ngb-dp-week ng-star-inserted ngb-dp-week-label-custom';
        } else {
          el.className = 'ngb-dp-week ng-star-inserted ngb-dp-week-custom';
        }
      });
      document.querySelectorAll('.ngb-dp-day.ng-star-inserted').forEach((el) => {
        el.className = 'ngb-dp-day ng-star-inserted ngb-dp-day-custom';
      });
      let x = document.querySelectorAll('.ngb-dp-day');
      if (this.dateToString(x[0]?.getAttribute('aria-label')) && this.dateToString(x[x.length - 1]?.getAttribute('aria-label'))) {
        this.fetchMonthlyViewForOrder(
          this.dateToString(x[0]?.getAttribute('aria-label')),
          this.dateToString(x[x.length - 1]?.getAttribute('aria-label'))
        );
      }
      this.showRecurringDay = false;
    }, 10);
  }

  dateToString(date: any) {
    let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [day, month, year].join('/');
  }
  fetchMonthlyViewForOrder(startDate, endDate) {
    if (this.fetchedMonth.filter((el) => el === startDate).length < 1 || this.isFromRecurring === true) {
      this.isFromRecurring = false;
      this.eventService
        .fetchWorkshopOpenDays({
          startDate: startDate,
          endDate: endDate,
          branch: this.defaultBranch,
        })
        .pipe(takeUntil(this.unSubscribe$))
        .subscribe((res: any) => {
          if (res) {
            (this.workshopOpenDates = res?.workshopOpenDates?.concat(
              this.workshopOpenDates?.filter((item) => res?.workshopOpenDates.indexOf(item) < 0)
            )),
              setTimeout(() => {
                let buttons = document.querySelectorAll('.ngb-dp-day:not(.disabled):not(.weekend)');
                buttons.forEach((btn) =>
                  this.renderer.listen(btn, 'click', () => {
                    setTimeout(() => {
                      //debugger
                      this.displayMonth(this.workshopOpenDates);
                    });
                  })
                );
                this.displayMonth(this.workshopOpenDates);
              });
          }
        });
      this.fetchedMonth.push(startDate);
    } else {
      this.displayMonth(this.workshopOpenDates);
    }
  }
  displayMonth(dates) {
    let x = document?.querySelectorAll('.ngb-dp-day');
    x?.forEach((y, i) => {
      if (y.getAttribute('aria-label')) {
        const dateSearch = this.dateToString(y.getAttribute('aria-label'));
        if (Number(dateSearch.split('/')[1]) === this.currentMonth) {
          if (moment(new Date()).isAfter(moment(dateSearch, 'DD/MM/YYYY'))) {
            document.getElementById(y.children[0].children[1].id).innerHTML = '';
            y.classList.add('customCss');
            document.getElementById(y.children[0].children[0].id).className = 'disabled';
            document.getElementById(y.children[0].id).addEventListener('click', function (e) {
              e.stopPropagation();
            });
          } else if (dates?.some((el) => el === dateSearch)) {
            document.getElementById(y.children[0].children[0].id).className = 'openedDayCss';
          } else {
            document.getElementById(y.children[0].children[0].id).className = 'closedDayCss';
          }
          if (
            moment(this.dateToString(x[15].getAttribute('aria-label')), 'DD/MM/YYYY').isBefore(moment(dateSearch, 'DD/MM/YYYY'), 'month') ||
            moment(this.dateToString(x[15].getAttribute('aria-label')), 'DD/MM/YYYY').isAfter(moment(dateSearch, 'DD/MM/YYYY'), 'month')
          ) {
            document.getElementById(y.children[0].children[0].id).classList.add('blur');
          }
          if (this.selectedworkshopDates?.find((el) => el === dateSearch)) {
            document.getElementById(y.children[0].children[0].id).className = 'selectedDateCss';
          }
        }
      }
    });
  }

  updateDate(day, month, year) {
    const dayStr = day.toString();
    const monthStr = month.toString();
    const yearStr = year.toString();
    const date = dayStr.padStart(2, '0') + '/' + monthStr.padStart(2, '0') + '/' + yearStr;
    if (moment(new Date()).isAfter(moment(date, 'DD/MM/YYYY'))) {
    } else if (this.workshopOpenDates?.some((el) => el === date)) {
      if (this.selectedworkshopDates?.filter((el) => el === date).length < 1) {
        this.selectedworkshopDates = [...this.selectedworkshopDates, date];
      } else {
        this.selectedworkshopDates = this.selectedworkshopDates?.filter((el) => el !== date);
      }

      this.displayMonth(this.workshopOpenDates);
      this.setWorkshopDayHourForm.valid;
    }
    if (this.selectedworkshopDates.length > 0) {
      this.isFormValid = true;
    } else {
      this.isFormValid = false;
    }
  }
  navigateCalendar(event) {
    this.currentMonth = event.next.month;
    let x = document.querySelectorAll('.ngb-dp-day');
    setTimeout(() => {
      if (x[0]?.getAttribute('aria-label') && x[x.length - 1]?.getAttribute('aria-label')) {
        this.fetchMonthlyViewForOrder(
          this.dateToString(x[0]?.getAttribute('aria-label')),
          this.dateToString(x[x.length - 1]?.getAttribute('aria-label'))
        );
      }
    }, 100);
  }

  onRecurringDaySelect(event) {
    console.log(event);
  }

  getColorDayStatus(day: string) {
    if (day)
      if (this.setWorkshopDayHourForm?.value?.recurringDays.some((el) => el === day)) {
        return 'green';
      }
  }

  changeDayStatus(day: string) {
    if (this.setWorkshopDayHourForm?.value?.recurringDays?.some((el) => el === day)) {
      if (this.setWorkshopDayHourForm?.value?.recurringDays?.some((el) => el === day)) {
        this.setWorkshopDayHourForm.patchValue({
          recurringDays: this.setWorkshopDayHourForm?.value?.recurringDays?.filter((item) => item !== day),
        });
      } else {
        this.setWorkshopDayHourForm.patchValue({
          recurringDays: [...this.setWorkshopDayHourForm?.value?.recurringDays, day],
        });
      }
    }
  }

  submitForm(): void {
    this.loading = true;
    if (this.setWorkshopDayHourForm) {
      let dataToUpdate = this.getDataToUpdate();
      // if change in ADho change
      if (this.selectedworkshopDates.length > 0) {
        dataToUpdate.recurringStartDate = '';
        dataToUpdate.recurringEndDate = '';
        dataToUpdate.recurringDays = [];
        this.eventService
          .changeWorkshopTimes(dataToUpdate)
          .pipe(takeUntil(this.unSubscribe$))
          .subscribe((data) => {
            if (data?.ErrorFlag === '0') {
              this.toastr.success(data?.ErrorMessage);
              this.activeModal.close(true);
            } else {
              this.toastr.success(data?.ErrorMessage);
            }
          });
      }
      // if change in Day
      if (
        this.setWorkshopDayHourForm?.value?.recurringStartDate &&
        this.setWorkshopDayHourForm?.value?.recurringDays.length > 0 &&
        this.selectedworkshopDates.length < 1
      ) {
        dataToUpdate.recurringStartDate = this.setWorkshopDayHourForm?.value?.recurringStartDate ?? '';
        dataToUpdate.recurringDays = this.setWorkshopDayHourForm?.value?.recurringDays ?? [];
        this.eventService
          .changeWorkshopTimes(dataToUpdate)
          .pipe(takeUntil(this.unSubscribe$))
          .subscribe((data) => {
            if (data?.ErrorFlag === '0') {
              this.toastr.success(data?.ErrorMessage);
              this.activeModal.close(true);
            } else {
              this.toastr.error(data?.ErrorMessage);
            }
          });
      }
      if (!dataToUpdate?.recurringStartDate && !(dataToUpdate?.recurringDays.length > 0)) {
        this.toastr.error('No change detected');
        this.activeModal.close(false);
      }
    } else {
      this.activeModal.close();
    }
    this.loading = false;
  }
  getDataToUpdate() {
    const dataToUpdate = {
      branch: this.defaultBranch,
      recurringStartDate: this.setWorkshopDayHourForm?.value?.recurringStartDate ?? '',
      recurringEndDate: this.setWorkshopDayHourForm?.value?.recurringEndDate ?? '',
      recurringDays: this.setWorkshopDayHourForm?.value?.recurringDays ?? [],
      workshopDates: this.selectedworkshopDates,
      startTime: getformatedTimeHHMMForApi(this.setWorkshopDayHourForm?.value?.schedulerSetHoursForm?.startTime) ?? 0,
      finishTime: getformatedTimeHHMMForApi(this.setWorkshopDayHourForm?.value?.schedulerSetHoursForm?.finishTime) ?? 0,
      break1Name: this.setWorkshopDayHourForm?.value?.schedulerSetHoursForm?.break1Name,
      break1StartTime: getformatedTimeHHMMForApi(this.setWorkshopDayHourForm?.value?.schedulerSetHoursForm?.break1StartTime) ?? 0,
      break1EndTime: getformatedTimeHHMMForApi(this.setWorkshopDayHourForm?.value?.schedulerSetHoursForm?.break1EndTime) ?? 0,
      break2Name: this.setWorkshopDayHourForm?.value?.schedulerSetHoursForm?.break2Name,
      break2StartTime: getformatedTimeHHMMForApi(this.setWorkshopDayHourForm?.value?.schedulerSetHoursForm?.break2StartTime) ?? 0,
      break2EndTime: getformatedTimeHHMMForApi(this.setWorkshopDayHourForm?.value?.schedulerSetHoursForm?.break2EndTime) ?? 0,
      break3Name: this.setWorkshopDayHourForm?.value?.schedulerSetHoursForm?.break3Name,
      break3StartTime: getformatedTimeHHMMForApi(this.setWorkshopDayHourForm?.value?.schedulerSetHoursForm?.break3StartTime) ?? 0,
      break3EndTime: getformatedTimeHHMMForApi(this.setWorkshopDayHourForm?.value?.schedulerSetHoursForm?.break3EndTime) ?? 0,
    };
    return dataToUpdate;
  }

  onCheckChange(day) {
    if (this.setWorkshopDayHourForm?.value?.recurringDays?.some((el) => el === day)) {
      this.setWorkshopDayHourForm.patchValue({
        recurringDays: this.setWorkshopDayHourForm?.value?.recurringDays?.filter((item) => item !== day),
      });
    } else {
      this.setWorkshopDayHourForm.patchValue({
        recurringDays: [...this.setWorkshopDayHourForm?.value?.recurringDays, day],
      });
    }
    if (this.setWorkshopDayHourForm?.value?.recurringStartDate && this.setWorkshopDayHourForm?.value?.recurringDays.length > 0) {
      this.isFormValid = true;
    } else {
      this.isFormValid = false;
    }
  }
  isDisabled = (date: NgbDateStruct, current: { month: number; year: number }) => {
    return current.month !== date.month;
  };
}

